module.exports = __webpack_public_path__ + "components/breakheader/static/icon--s2-09fbbbddeef0986aacd349e24b015f25.svg";